import React from "react";
import { ScoringRulesPresets } from "./ScoringRulesPresets";

/**
 * Scoring Rules Configuration Component
 * Allows admins to select from preset scoring rule configurations
 */
export function ScoringRulesConfig({ 
  scoringRules = {}, 
  onChange, 
  maxPointsPerJudge = 100,
  className = "" 
}) {
  // Only use defaults if no rules have been configured at all
  // Check if scoringRules is truly empty (no meaningful configuration)
  const hasExistingConfig = scoringRules && (
    Object.keys(scoringRules).length > 0 && (
      scoringRules.minJudges !== undefined ||
      scoringRules.maxJudges !== undefined ||
      scoringRules.targetTotalScore !== undefined ||
      scoringRules.dropLowestScore !== undefined ||
      (scoringRules.dropScoreConditions && scoringRules.dropScoreConditions.length > 0) ||
      (scoringRules.tieBreakingRules && scoringRules.tieBreakingRules.length > 0) ||
      (scoringRules.missingJudgeRules && scoringRules.missingJudgeRules.length > 0)
    )
  );

  // If no existing config, start with empty rules, otherwise use the existing config
  const currentRules = hasExistingConfig ? scoringRules : {
    // Start with minimal empty structure
    minJudges: undefined,
    maxJudges: undefined,
    targetTotalScore: undefined,
    maxPointsPerJudge: maxPointsPerJudge,
    dropLowestScore: false,
    dropScoreConditions: [],
    tieBreakingRules: [],
    missingJudgeRules: [],
    validationRules: {
      requireMinimumJudges: false,
      allowPartialScoring: true,
      enforceScoreRanges: true
    }
  };

  return (
    <div className={className}>
        {/* Scoring Rules Presets */}
        <ScoringRulesPresets
          onSelectPreset={onChange}
          currentRules={currentRules}
        />
    </div>
  );
}